// extracted by mini-css-extract-plugin
module.exports = {"suggestEditButton":"styles_suggestEditButton__z320_"};